// import { StrictMode } from 'react'
// import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from "react-dom/client";
import React from "react";
import { CssBaseline, GlobalStyles } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { registerSW } from './registerSW.ts';
import { buildInfo } from "./lib/buildInfo";


// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker.register("/service-workerNO.js");
// }

// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker.register("/service-workerNO.js").then((reg) => {
//       console.log("Service worker registered.", reg);

//       // Listen for updates
//       reg.addEventListener("updatefound", () => {
//         const newWorker = reg.installing;
//         if (!newWorker) return;
//         newWorker.addEventListener("statechange", () => {
//           if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
//             // NEW VERSION AVAILABLE
//             console.log("A new version is available!");
//             // Later: you will show a toast to refresh
//           }
//         });
//       });
//     });
//   });
// }

// registerSW((reg) => {
//   // Dispatch a custom event we can listen for inside React
//   window.dispatchEvent(new CustomEvent('sw.update', { detail: reg }));
// })
// console.log('pre-register attempt');
// if (import.meta.env.PROD) {
//   console.log('registering PROD attempt');
//   // registerSW((reg) => {
//   //   window.dispatchEvent(new CustomEvent('sw.update', { detail: reg }));
//   // });
// }

  // registerSW((reg) => {
  //   window.dispatchEvent(new CustomEvent('sw.update', { detail: reg }));
  //   });

if (!import.meta.env.DEV) {
  registerSW((reg) => {
    window.dispatchEvent(new CustomEvent('sw.update', { detail: reg }));
  });
}



// const theme = createTheme({
//   palette: {
//     mode: "light",
//   },
// });

export const theme = createTheme({
  shape: {
    borderRadius: 12, // Material You roundedness
  },
  palette: {
    primary: {
      main: "#1E88E5", // Modern Material Blue
    },
    background: {
      default: "#f6f6f6",
      paper: "#ffffff",
    },
  },
  components: {
    MuiTouchRipple: {
      styleOverrides: {
        rippleVisible: {
          opacity: 0.15,
        },
        child: {
          backgroundColor: "rgba(30, 136, 229, 0.3)", // ripple color
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          "&:active": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        },
      },
    },
  },
});

// createRoot(document.getElementById('root')!).render(
//   <StrictMode>
//     <App />
//   </StrictMode>,
// )

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "always",
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://25282e8169b9511822e292d1804e8b84@o4510447182938112.ingest.de.sentry.io/4510448943366224",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      // keep any other Replay options here
    })
  ],
  release: buildInfo.version,
  dist: buildInfo.number,
  environment: import.meta.env.MODE ?? (import.meta.env.DEV ? "development" : "production"),
  initialScope: (scope) => {
    scope.setTag("build_number", buildInfo.number);
    scope.setTag("build_datetime", buildInfo.dateTime);
    return scope;
  },
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// const container = document.getElementById("app");
// const root = createRoot(container);
// root.render(<App />);

function GoogleMapsStyleGuard() {
  React.useEffect(() => {
    const disableInjectedStyles = () => {
      document.querySelectorAll("style").forEach((styleEl) => {
        if ((styleEl as any)._gmDisabled) return;
        const content = styleEl.textContent || "";
        if (content.includes("gm-style") && content.includes("Roboto")) {
          styleEl.disabled = true;
          (styleEl as any)._gmDisabled = true;
        }
      });
    };

    disableInjectedStyles();
    const observer = new MutationObserver(disableInjectedStyles);
    observer.observe(document.head, { childList: true });
    return () => observer.disconnect();
  }, []);
  return null;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <GoogleMapsStyleGuard />
          <CssBaseline />
          <GlobalStyles
            styles={{
              "body, button, input, select, textarea": {
                fontFamily: `${theme.typography.fontFamily} !important`,
                fontSize: "1rem !important",
                lineHeight: 1.5,
              },
            }}
          />
          <App />
        </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
